import * as React from "react";
import { Component } from 'react';
import Layout from '../components/global/layout.js'
import Content from '../components/500/content.js'
import '@fortawesome/fontawesome-free/css/all.css';
import '../sass/app.scss';

class ServerError extends Component {
  render() {
    return (
      <>
        <Layout section="500" page="500">
          <Content section="500" page="500" />
        </Layout>
      </>
    )
  }
}

export default ServerError;
